export default __webpack_public_path__ + "static/media/playup-myaccount.ff98ebb8.svg";